import { Component, OnInit, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

export const CustomPopupUIAnimations = [trigger('pcDivUIState', [
  state('false', style({
    opacity: 0
  })),
  state('true', style({
    opacity: 1
  })),
  transition('* => true', animate('100ms ease-in')),
  transition('true => *', animate('100ms ease-out'))
])];

@Component({
  selector: 'app-custom-popup',
  templateUrl: './custom-popup.component.html',
  styleUrls: ['./custom-popup.component.scss'],
  animations: CustomPopupUIAnimations
})
export class CustomPopupComponent implements OnInit, AfterViewInit {

  showHeader = true;
  showBody   = true;
  showFooter = true;
  showCmpnt = 'false';

  @ViewChild('headerDiv', {read: ElementRef, static: false}) headerDivEleRef: ElementRef;
  @ViewChild('bodyDiv', {read: ElementRef, static: false}) bodyDivEleRef: ElementRef;
  @ViewChild('footerDiv', {read: ElementRef, static: false}) footerDivEleRef: ElementRef;

  constructor() { }

  ngOnInit()
  {
  }

  ngAfterViewInit()
  {
    setTimeout(() => {
      this.showCmpnt = 'true';

      if ((this.headerDivEleRef) && (this.headerDivEleRef.nativeElement.children.length > 0))
      {
        this.showHeader = true;
      }
      else
      {
        this.showHeader = false;
      }

      if ((this.bodyDivEleRef) && (this.bodyDivEleRef.nativeElement.children.length > 0))
      {
        this.showBody = true;
      }
      else
      {
        this.showBody = false;
      }

      if ((this.footerDivEleRef) && (this.footerDivEleRef.nativeElement.children.length > 0))
      {
        this.showFooter = true;
      }
      else
      {
        this.showFooter = false;
      }
    }, 0);
  }

  shouldShowHeader(): boolean
  {
    return this.showHeader;
  }

  shouldShowBody(): boolean
  {
    return this.showBody;
  }

  shouldShowFooter(): boolean
  {
    return this.showFooter;
  }
}
